export function shareCollage () {
  this.$service
    .getGoodsDetails({
      skuId: this.goodsId
    })
    .then(res => {
      console.log('生成海报的商品信息', res)
      this.goodsInfo = res.data
      const goodsImg = res.data.skuThumb
      let goodsName1 = ''
      let goodsName2 = ''
      let params
      const qrcodeContext = this.getShareLink()
      // 如果大于11长度,就分解为2行
      for (let a = 0; a < this.goodsInfo.title.length; a++) {
        if (a < 11) {
          goodsName1 = `${goodsName1}${this.goodsInfo.title.charAt(a)}`
        } else {
          goodsName2 = `${goodsName2}${this.goodsInfo.title.charAt(a)}`
        }
      }
      params = {
        action: 'combie',
        backgroundColor: 'ffffff',
        backgroundWidth: this.isShiWu ? 298 * 4 : 590 * 2,
        backgroundHeight: this.isShiWu ? 440 * 4 : 944 * 2,
        items: [
          {
            context: this.isShiWu
              ? 'https://img2.coocaa.com/ui/partner-mini-program/partner/goods-sharing.png'
              : 'https://img2.coocaa.com/ui/partner-mini-program/virtual-goods-share.png',
            coordinateX: 0,
            coordinateY: 0,
            shapeWidth: this.isShiWu ? 298 * 4 : 590 * 2,
            shapeHeight: this.isShiWu ? 2000 : 944 * 2,
            type: 'image'
          },
          {
            context: this.userInfo.headUrl,
            coordinateX: 140,
            coordinateY: 90,
            shapeHeight: 35 * 4,
            shapeWidth: 35 * 4,
            type: 'image',
            cornerRadius: 50
          },
          {
            context: `好友 ${this.userInfo.nickName}`,
            coordinateX: 140 + 170,
            coordinateY: 150,
            fontColor: '666666',
            fontSize: 12 * 4,
            textLineHeight: 10 * 4,
            type: 'text'
          },
          {
            context: '发现一个好物推荐给您啦',
            coordinateX: 140 + 170,
            coordinateY: 220,
            fontColor: '333333',
            fontSize: 12 * 4,
            textLineHeight: 10 * 4,
            type: 'text'
          },
          {
            context: goodsImg,
            coordinateX: 100,
            coordinateY: 270,
            shapeWidth: 231 * 4,
            shapeHeight: 164 * 4,
            backgroundColor: '000000',
            coordinateCenter: true,
            type: 'image'
          }
        ]
      }
      params.items.push({
        context: goodsName1,
        coordinateX: 145,
        coordinateY: 265 * 4,
        fontColor: '000000',
        fontSize: 14 * 4,
        textLineHeight: 20 * 4,
        type: 'text'
      })
      if (goodsName2) {
        params.items.push({
          context: goodsName2,
          coordinateX: 145,
          coordinateY: 285 * 4,
          fontColor: '000000',
          fontSize: 14 * 4,
          textLineHeight: 20 * 4,
          type: 'text'
        })
      }
      params.items.push(
        {
          context: `¥${this.goodsInfo.sellPrice}`,
          coordinateX: 140,
          coordinateY: this.isShiWu ? 1250 : 315 * 4,
          fontColor: 'FE1800',
          fontSize: 20 * 4,
          textLineHeight: 40 * 4,
          type: 'text'
        },
        {
          context: qrcodeContext,
          coordinateX: this.isShiWu ? 800 : 180 * 4,
          coordinateY: 250 * 4,
          shapeHeight: 72 * 4,
          shapeWidth: 72 * 4,
          type: 'qrcode'
        },
        {
          context: '长按识别购买',
          coordinateX: this.isShiWu ? 800 : 180 * 4,
          coordinateY: 330 * 4,
          fontColor: '999999',
          fontSize: 12 * 4,
          textLineHeight: 17 * 4,
          type: 'text'
        }
      )
      if (!this.isShiWu) {
        params.items.push({
          context:
            'https://img2.coocaa.com/ui/partner-mini-program/min-program-qr-code.png',
          coordinateX: 200 * 4,
          coordinateY: 400 * 4,
          shapeWidth: 56 * 4,
          shapeHeight: 56 * 4,
          type: 'image'
        })
      }
      this.$service.action(params).then(res => {
        this.sharePicPop = true
        this.showPop = false
        this.sharePic = `data:image/png;base64,${res.data.base64Value}`
      })
      this.$service.growthValueTask({
        taskType: '100702'
      })
    })
}
